module.exports = __webpack_public_path__ + "public/img/lu.a92908e6.png";